module.exports = __webpack_public_path__ + "img/forget-title.e925ec67.png";